var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comeDownBox"},[_c('div',{staticClass:"contentBox"},[_c('ComeDownMiddle',{attrs:{"link":_vm.link,"classList":_vm.classList}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }